import ApiClient from '@/utils/apiClient'

class LogService {
  apiClient: any
  constructor() {
    this.apiClient = new ApiClient(import.meta.env.VITE_DX_API_URL)
  }

  addLog = async (bpId: number | null, logData: string, isFinal: boolean): Promise<void> => {
    await this.apiClient.post(`businessProfiles/${bpId}/creativeLog`, { logData, isFinal });
  }
}

export default LogService